import {
  DashboardSummary,
  DailySalesData,
  SalesAnalytics,
  TopProduct,
} from "../types/dashboard";

import apiClient from "./api";

class DashboardService {
  /**
   * Fetch dashboard summary data
   */
  async getDashboardSummary(): Promise<DashboardSummary> {
    return await apiClient.get<DashboardSummary>("/dashboard/summary");
  }

  /**
   * Fetch daily sales data
   */
  async getDailySales(days: number = 7): Promise<DailySalesData> {
    return await apiClient.get<DailySalesData>(
      `/dashboard/sales/daily?days=${days}`,
    );
  }

  /**
   * Fetch weekly sales data
   */
  async getWeeklySales(weeks: number = 8): Promise<any> {
    return await apiClient.get<any>(`/dashboard/sales/weekly?weeks=${weeks}`);
  }

  /**
   * Fetch top selling products
   */
  async getTopProducts(
    days: number = 30,
    limit: number = 10,
  ): Promise<TopProduct[]> {
    return await apiClient.get<TopProduct[]>(
      `/dashboard/top-products?days=${days}&limit=${limit}`,
    );
  }

  /**
   * Fetch low stock items
   */
  async getLowStockItems(limit: number = 10): Promise<any[]> {
    return await apiClient.get<any[]>(`/dashboard/low-stock?limit=${limit}`);
  }

  /**
   * Fetch sales analytics data
   */
  async getSalesAnalytics(days: number = 30): Promise<SalesAnalytics> {
    return await apiClient.get<SalesAnalytics>(
      `/dashboard/sales/analytics?days=${days}`,
    );
  }
}

// Create singleton instance
export const dashboardService = new DashboardService();
